module.exports = __webpack_public_path__ + "img/blue-bar.21f72f6c.svg";